export const languageResources = {
  en_US:{
    controlMsg:{
      backButton:"Previous",
      nextButton:"Continue",
      homeButton:"Return Home"
    },
    recruitMsg:{
      studyMsg:" {StudyName}.",
      backButton:"Back",
      backButtonMsg:"I want to review my available session(s) and make changes.",
      scheduleButton:"Schedule",
      scheduleButtonMsg:"I want to proceed scheduling for the session's.",
      confirmButton:"Confirm",
      confirmButtonMsg:"I want to confirm my availability for the session.",
      declineButton:"Decline",
      declineButtonMsg:"I want to decline my participation.",
      scheduleMsg:"Please make a selection from the below session's.",
      rescheduleMsg:"To reschedule, please make a selection from the below session's.",
      rescheduleButton:"Reschedule",
      rescheduleButtonMsg:"I want to review my available session(s) and make changes.",
      rescheduleContinueButton:"Schedule",
      rescheduleContinueButtonMsg:"I want to schedule my availability for the above.",
      cancelConfirmButton:"Confirm cancellation",
      cancelConfirmButtonMsg:"I want to confirm my cancellation.",
      cancelButton:"Cancel",
      cancelButtonMsg:"I want to cancel my participation in this study.",
      skipButton:"Skip",
      skipButtonMsg:"I want to skip making any changes.",
      standByMsg:"You will be on standby for this session.",
      subSessionMessage:"You will also be required to participate in the following days.",
      subSessionCancelMessage:"You will also be cancelled in the following days.",
      basicSessionErrorMsg:"Please make a selection for the session you want to schedule for.",
      clusterMessage:"Select a minimum of {min} and maximum of {max} from the below sessions",
      clusterErrorMsg:"Your selection is Invalid",
      clusterSuccessMsg:"Your selection is valid",
      submitScheduleErrorMsg:"The session(s) you selected could not be scheduled, please try again.",
      selection:{
        heading:"Session Selection",
      },
      scheduled:{
        heading:"Current Schedule",
        message:"You are schedule for the following sessions for Study: {StudyName}.",
      },
      confirmation:{
        heading:"Session Confirmation",
        message:"You are confirming to participate in the following session(s). Please review and confirm your selections.",
        standByConfirmMsg:"You are on standby."
      },
      decline:{
        heading:"Session Decline",
        message:"You are choosing to decline your participation for Study: {StudyName}. Are you sure?",
      },
      cancel:{
        heading:"Session Cancel",
        message:"You are choosing to remove yourself from participating for Study: {StudyName}. Are you sure?",
      },
      scheduleRestrictionMsg:"Panelist are restricted to {operations}, their current schedule"
    },
    getResponseMsg: { 
      placeholder: "Please select a value.",
      otherPlaceHolder: "Please enter a custom value.",
      noResponseErrorMsg: "Please select an answer from the provided choices.",
      otherErrorMsg: "Please enter a valid custom value."
     },
     getValueMsg: { 
      SSN:{
        hint:"Example: 123-45-6789.",
        error:"Please enter a valid social security number, Example: 123-45-6789."
      },
      numeric:{
        hint:"Minimum: {min} digits, Maximum: {max} digits.",
        error:"The value must be a minimum of {min} digits and a maximum of {max} digits long."
      },
      text:{
        hint:"Minimum: {min} characters, Maximum: {max} characters.",
        error:"The value must be a minimum of {min} characters and a maximum of {max} characters long."
      },
      password:{
        hint:"Password must be minimun {min} and a maximum {max} characters long.",
        error:"Password must be minimun {min} and a maximum {max} characters long."
      },
      date:{
        error:"Please select a valid date."
      },
      time:{
        error:"Please select a valid time."
      },
      email:{
        error:"Please enter a valid email."
      },
      confirmValueSuccess: "The values match!",
      confirmValueError: "The values do not match."
    },
    authenticateMsg: { 
      userPlaceholder: "",
      passPlaceholder: "",
      userNoValue: "{Username} Cannot be empty.",
      passNoValue: "{Password} Cannot be empty."
     },
     blockMsg: { 
      error: "Please check your responses. Not all of your answers appear valid.",
      sumToLabel :"Total: ",
      sumToHint :"Hint: The sum of all your answers must be equal to {sumto}.",
      sumToError :"The sum of all your answers must be equal to {sumto}.",
      sumToSuccess :"The sum of all your answers is equal to {sumto}."

    },
    multiResponseMsg: {
      hint: "Hint: Minimum: {min} answers, Maximum: {max} answers.",
      error: "Please select a minimum of {min} and a maximum of {max} answers.",
    },
    fileUploadMsg:{
      noReponseError: "Please select a file to upload.",
      fileTypeError: "Upload only files of type {filetype}.",
      fileSizeError: "Upload only files of size {size}.",
      upload: {
        "dropFilesHere": "Drop files here to upload",
        "headerStatusUploaded": "Done",
        "headerStatusUploading": "Uploading...",
        "invalidFileExtension": "File type not allowed.",
        "invalidMaxFileSize": "File size too large.",
        "remove": "Remove",
        "retry": "Retry",
        "select": "Select files...",
        "statusUploaded": "File(s) successfully uploaded.",
        "statusUploadFailed": "File(s) failed to upload."
      }
    },
    scaleMatrixMsg: { 
      noResponseErrorMsg: "Please provide answers to all the questions.",
     },
     rankingMsg: { 
      placeholder: "Make selection.",
      noResponseErrorMsg: "Please make selection to all the questions & select unique answers to each question",
     },
     thankYouMsg:{
      header:"Thank You",
      surveyMessage:"We will contact you soon with further details.",
      postSurveyRescheduleMessage:"Your session is rescheduled successfully",
      postSurveyCancelMessage:"You session is cancelled successfully"
     },
     timeOutMsg:{
      header:"Time Out!",
      message:"You have been timed out due to inactivity.",
      notification:"You are about to be timeout in {seconds} seconds, due to inactivity."
     },
     errorMsg:{
      header:"Uh-Oh",
      panelistScheduleError:"Failed to schedule panelist,Please contact your study administrator",
      panelistReScheduleError:"Failed to re-schedule panelist,Please contact your study administrator",
      panelistStatusUpdateError:"Failed to update panelist status, Please contact your study administrator",
      authenticationError:"Failed to authenticate panelist,Please contact your study administrator",
      authorizationError:"Failed to authorize panelist,Please contact your study administrator",
      unExpectedError:"There was a problem, we are working hard to have this fixed as soon as possible.",
      noScheduleAvailableMessage:"Unfortuantely, No other sessions are available for reschedule.",
      surveyInitilizationError:"Failed to start survey, Pls check your input paramaters and try again",
      studyNotAvalable:"Study is not available, Please contact your study administrator.",
      apiErrorMessage:"Your request could not be processed, Please try again.",
      legacyModeErrorMsg:"Study is configured to work in legacy mode."
     }
  }
}

